import BaseService from './BaseService'
import * as apiroutes from '../apiRoutes'

class DashboardService extends BaseService {
    constructor() {
        super(apiroutes.DASHBOARD)
    }

    async getSummary(params = {}) {
        return await super.customCall('GET', '/summary', null, params, null)
    }

    async getCommentsByStatus(params = {}) {
        return await super.customCall('GET', '/reports/comments-by-category', null, params, null)
    }

    async getDocumentVersionsByStatus(params = {}) {
        return await super.customCall('GET', '/reports/document-versions-by-status', null, params, null)
    }

    async getUpcomingDeadlines(params = {}) {
        return await super.customCall('GET', '/reports/upcoming-deadlines', null, params, null)
    }
}

const DashboardServices = new DashboardService()
export default DashboardServices
